export function extractMetricSubscriptionFields(metrics) {
	const fields = ['metricId', 'conversion', 'customUnit', 'conversionUnit', 'unitType']

	return metrics.map(m => {
		const result = {}
		fields.forEach(field => {
			if(m[field] !== null && m[field] !== undefined){
				result[field] = m[field]
			}
		})

		return result
	})
}
